import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, ItemContent, Skeleton, SkeletonBlock, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { Item } from "../Item";
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants";
export const ReceiptRowDisplaySkeleton = () => {
  const $ = _c(24);
  const {
    size
  } = useTable();
  let T0;
  let T1;
  let T2;
  let T3;
  let t0;
  let t1;
  let t2;
  if ($[0] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    T3 = TableRow;
    T2 = TableCell;
    t2 = RECEIPT_TABLE_COLUMN_CLASSNAMES.item;
    T1 = Item;
    t1 = "unstyled";
    T0 = SkeletonBlock;
    t0 = classNames(image(), "w-fit");
    $[0] = size;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = T3;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    T3 = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== T0 || $[9] !== t0) {
    t3 = <T0 className={t0} />;
    $[8] = T0;
    $[9] = t0;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ItemContent><Skeleton className="w-24" /><Skeleton className="w-20" /></ItemContent>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== T1 || $[13] !== t1 || $[14] !== t3) {
    t5 = <T1 variant={t1}>{t3}{t4}</T1>;
    $[12] = T1;
    $[13] = t1;
    $[14] = t3;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== T2 || $[17] !== t2 || $[18] !== t5) {
    t6 = <T2 className={t2}>{t5}</T2>;
    $[16] = T2;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}><FlexColumn className="items-end"><Skeleton className="w-12" /><Skeleton className="w-16" /></FlexColumn></TableCell>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== T3 || $[22] !== t6) {
    t8 = <T3>{t6}{t7}</T3>;
    $[21] = T3;
    $[22] = t6;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};